<div class="main-v2-call-component" [class.speaking]="agentSpeakingState">
  <video
    autoplay
    muted
    loop
    #bgVideoRef
    class="animation-bg-video"
  >
    <source src="assets/images/interviewAgentV2CallBgAnimation.mp4" type="video/mp4" />
  </video>

  <div class="wave-variations-bg" [class.outerWaveAnimating]="agentSpeakingState">
    <div class="main-agent-bg">
      <div class="main-agent-avatar-container" [class.small]="isSizeSmall">
        <div class="audio-variations">
          <img [src]="commonService.Images.MALE_VOICE_ASSISTANT" alt="">
        </div>
      </div>
    </div>
  </div>
</div>
